import React from 'react';
import cn from 'clsx';
import styles from './styles.module.scss';
import Loader from '@components-clean/core/loader';

export enum LoaderPosition {
    center = 'center',
    bottom = 'bottom',
}

interface LoadingProps {
    position?: LoaderPosition;
}

const Loading = ({ position = LoaderPosition.center }: LoadingProps) => {
    return (
        <div
            className={cn('k-pos-absolute', {
                [styles.loaderCenter]: position === LoaderPosition.center,
                [styles.loaderBottom]: position === LoaderPosition.bottom,
            })}
        >
            <Loader />
        </div>
    );
};

export default Loading;
